<template>
  <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
    <BaseForm
      :action="
        () => {
          return handleSubmit(submitAction);
        }
      "
      v-slot="formProps"
      class="grid gap-4"
    >
      <ValidationProvider rules="required" name="url" tag="div" vid="url">
        <template #default="{ errors, failed }">
          <BaseFormGroup>
            <BaseFormLabel>Url</BaseFormLabel>
            <BaseFormInput
              v-model="formData.url"
              type="url"
              :disabled="formProps.isPending"
              :invalid="failed"
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>

      <ValidationProvider name="title" tag="div" vid="title">
        <template #default="{ errors, failed }">
          <BaseFormGroup>
            <BaseFormLabel>Title</BaseFormLabel>
            <BaseFormInput
              v-model="formData.title"
              :disabled="formProps.isPending"
              :invalid="failed"
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>

      <ValidationProvider name="description" tag="div" vid="description">
        <template #default="{ errors, failed }">
          <BaseFormGroup>
            <BaseFormLabel>Description</BaseFormLabel>
            <BaseFormTextarea
              v-model="formData.description"
              :disabled="formProps.isPending"
              :invalid="failed"
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>

      <div class="grid grid-flow-col gap-2 justify-start">
        <BaseButton primary :disabled="invalid || formProps.isPending || formProps.isRejected">
          Create
        </BaseButton>
      </div>
    </BaseForm>
  </ValidationObserver>
</template>

<script>
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  mixins: [veeValidateErrorsMixin],
  props: {
    submit: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        url: null,
        title: null,
        description: null,
      },
    };
  },
  methods: {
    resetForm() {
      this.formData.url = null;
      this.formData.title = null;
      this.formData.description = null;
    },
    async submitAction() {
      try {
        await this.submit(this.formData);

        this.resetForm();

        return Promise.resolve();
      } catch (error) {
        if (error?.status === HTTP_UNPROCESSABLE_ENTITY) {
          this.observer = this.$refs.observer;
          this.addServerErrors(error.data.errors);
        }
        return Promise.reject();
      }
    },
  },
};
</script>
